<template>
    <el-container>
        <el-main>
            <el-form
                :inline="true"
                :model="formLoginProcess"
                ref="formLoginProcess"
                :label-position="labelPosition"
                :label-width="labelWith"
                :rules="rules"
                class="demo-form-inline"
                @submit.native.prevent
            >
                <td-permission :permissions="['loginConfig:view']">
                    <template slot="havePermission">
                        <el-row>
                            <el-form-item :label="$t('loginProcess.select_loginProcess')" prop="loginProcess">
                                <td-checkbox-group v-model="formLoginProcess.enableLoginProcess" :allList="loginProcess" keys="sId" text="sCheckTypeName"></td-checkbox-group>
                            </el-form-item>
                        </el-row>
                        <el-row>
                            <el-form-item :label="$t('loginProcess.login_ruler')" prop="loginType">
                                <td-radio :options="options" v-model="formLoginProcess.loginType"></td-radio>
                            </el-form-item>
                        </el-row>
                        <el-col :offset="3" style="padding-top:10px">
                            <td-button type="primary" :permissions="['loginConfig:edit']" @click="updateLoginProcess">{{ $t('loginProcess.save') }}</td-button>
                            <td-button @click="listLoginProcess">{{ $t('loginProcess.reset') }}</td-button>
                        </el-col>
                    </template>
                </td-permission>
            </el-form>
        </el-main>
    </el-container>
</template>
<script>
import api from './assets/api.js';
export default {
    data() {
        return {
            labelWith: '120px',
            formLoginProcess: {
                enableLoginProcess: [],
                loginType: window.authCommon.loginProcess.allLoginProcess
            },
            loginProcess: [],
            options: [
                {
                    value: window.authCommon.loginProcess.onlyLoginProcess,
                    label: window.vue.$t('loginProcess.only_login_process_validation_successful')
                },
                {
                    value: window.authCommon.loginProcess.allLoginProcess,
                    label: window.vue.$t('loginProcess.all_login_process_validation_successful')
                }
            ]
        };
    },
    created() {
        this.listLoginProcess();
    },
    methods: {
        listLoginProcess() {
            api.listLoginProcessByCondition({ systemId: window.app.sPlatformFlg }, response => {
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$log.error('loginProcess/listLoginProcess', response.data.statusMessage);
                }
                this.formLoginProcess.enableLoginProcess = [];
                this.loginProcess = response.data.content;
                response.data.content.forEach(item => {
                    if (item.iVerifyEnable == window.authCommon.loginProcess_enable.yes) {
                        this.formLoginProcess.enableLoginProcess.push(item.sId);
                        if (item.iLogic == window.authCommon.loginProcess.onlyLoginProcess) {
                            this.formLoginProcess.loginType = window.authCommon.loginProcess.onlyLoginProcess;
                        }
                    }
                });
            });
        },
        //更新登录程序
        async updateLoginProcess() {
            //先校验是否满足开启条件
            let checkMethods = [];
            let resultProcess = this.$util.clone(this.loginProcess);
            for (let i = 0; i < resultProcess.length; i++) {
                let process = resultProcess[i];
                let isSelect = false;
                this.formLoginProcess.enableLoginProcess.forEach(processId => {
                    if (processId == process.sId) {
                        isSelect = true;
                    }
                });
                if (isSelect) {
                    process.iVerifyEnable = window.authCommon.loginProcess_enable.yes;
                    process.iLogic = this.formLoginProcess.loginType;
                    if (process.sCheckType != 'Password') {
                        let loginMethod = window.validateLogon.loginMethod.get(process.sCheckType);
                        if (loginMethod === undefined) {
                            this.$message({ showClose: true, message: process.sCheckTypeName + this.$t('loginProcess.error_prcess'), type: 'error' });
                            return;
                        }
                        checkMethods.push(loginMethod.checkProcess());
                    }
                } else {
                    process.iVerifyEnable = window.authCommon.loginProcess_enable.no;
                }
            }
            await Promise.all(checkMethods).then(function(results) {
                console.info('results', results);
                for (let i = 0; i < results.length; i++) {
                    if (!results[i].ret) {
                        window.vue.$message({ showClose: true, message: results[i].message, type: 'error' });
                        return;
                    }
                }
                //更新登录程序
                api.updateLoginProcessByCondition(resultProcess, response => {
                    if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                        window.vue.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                        window.vue.$log.error('loginProcess/updateLoginProcessByCondition', response.data.statusMessage);
                        return;
                    }
                    //更新需要验证的登录程序
                    api.listLoginProcess({ sysId: window.app.sPlatformFlg }, response1 => {
                        if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                            window.vue.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            window.vue.$log.error('loginProcess/listLoginProcess', response.data.statusMessage);
                            return;
                        }
                        //更新登录程序
                        window.validateLogon.loginPorcess = response1.data.content.mustVerifyLoginProcessList;
                        window.validateLogon.verifyOneLoginProcess = response1.data.content.verifyOneLoginProcessList;
                        window.vue.$message({ showClose: true, message: response1.data.statusMessage, type: 'success' });
                        return;
                    });
                });
            });
        }
    }
};
</script>
